import FormattedMessage from 'I18n/components/FormattedMessage';
import { SignupButton } from 'purchase-motions-components/components/PurchaseMotions/SignupButton/SignupButton';
import anchorCtaTranslations from 'i2l?query=sporks!../../../lang/anchor-cta/en.lyaml';
import { AnchorCtaSection } from 'pricing-pages-ui-components/anchor-cta/AnchorCtaSection';
import { useScopedTranslations } from 'pricing-pages-ui-components/i18n/useScopedTranslations';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useContext } from 'react';
import { PublicI18nContext } from '../../context/I18nContext';
import { TRACKING_SOURCES, trackSignupButtonClick } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicAnchorCtaSectionWrapper = ({
  productApiName,
  screen
}) => {
  const {
    i18nLoader
  } = useContext(PublicI18nContext);
  const T = useScopedTranslations(anchorCtaTranslations, i18nLoader);
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsx(T.Skeleton, {
      widths: ['60%', '100%'],
      heights: [44, 48],
      children: /*#__PURE__*/_jsx(AnchorCtaSection, {
        heading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.anchorCta.heading"
        }),
        ctas: /*#__PURE__*/_jsx(SignupButton, {
          apiName: productApiName,
          trackingData: {
            app: 'pricing-pages',
            source: TRACKING_SOURCES.ANCHOR_CTA_SECTION,
            screen,
            uniqueId: `anchor-cta-${productApiName}`
          },
          onClick: () => trackSignupButtonClick({
            trackingSource: TRACKING_SOURCES.ANCHOR_CTA_SECTION,
            screen,
            productNames: [productApiName]
          }),
          uiButtonProps: {
            use: 'primary',
            block: true
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publicPricingPage.anchorCta.cta"
          })
        })
      })
    })
  });
};